import React from 'react'
import { Spinner } from 'react-bootstrap'

const SideBarLoader = () => {
    return (
        <div className="sidebar">
            <div className="scrollbar-container sidebar-nav">
                <div className="sidebar-loader">
                    <Spinner animation="border" role="status" variant="primary" />
                    <div className="loader-text">Loading sidebar...</div>
                </div>
            </div>
        </div>
    )
}

export default SideBarLoader